import { WebHostingRouterInput } from '@nucleus/web-hosting';
import { useWebHostingApi } from '@nucleus/web-theme';
import { infiniteQueryOptions, useSuspenseInfiniteQuery } from '@tanstack/react-query';

type CollectionListInput = WebHostingRouterInput['postHub']['collection']['list'];

export const useCollections = (
  engineId: string | undefined,
  collection?: CollectionListInput['collectionType'],
  params?: Omit<CollectionListInput, 'hubId' | 'collectionType'>
) => {
  const api = useWebHostingApi();

  const options = api.postHub.collection.list.infiniteQueryOptions(
    {
      hubId: engineId!,
      collectionType: collection ?? 'postCollections',
      ...params,
    },
    {
      getNextPageParam: (lastPage) => lastPage.cursor,
    }
  );

  const defaultOptions = infiniteQueryOptions({
    queryKey: options.queryKey,
    queryFn: async () => ({ collections: [], cursor: undefined }),
    initialPageParam: undefined,
    getNextPageParam: () => undefined,
  }) as unknown as typeof options;

  return useSuspenseInfiniteQuery(engineId === undefined ? defaultOptions : options);
};
